import { createFileRoute } from '@tanstack/react-router';
import RecruitingProjectionPage from '../../../pages/RecruitingProjectionPage';

export const Route = createFileRoute('/_authenticated/$owner/projection')({
  component: RouteComponent
});

function RouteComponent() {
  return <RecruitingProjectionPage />;
}
